{
    "AutocalcdurationLabel": "Calcular automaticamente a duração ao programar o relatório:",
    "BundleallemailattachinzipLabel": "Agrupe todos os anexos de e-mail dentro de um arquivo zip:",
    "RunandcollatewithsimilarschedLabel": "Executar e agrupar com agendamentos de relatórios periódicos semelhantes:",
    "Advanced_SectionHeader": "Avançado",
    "NAME": "Advanced"
}